<template>
    <div class="interactive-map">
        <div style="touch-action: none" class="position-relative" ref="wrapper" @touchstart="startDrag" @touchmove="handleMouseMove" @touchend="stopDrag" @mousedown="startDrag" @mouseup="stopDrag" @mousemove="handleMouseMove" :style="{ height: wrapperHeight +'px', backgroundImage : 'url('+ mapImage +')', backgroundPosition: (backgroundOffsetX+tempOffsetX) +'px '+ (backgroundOffsetY+tempOffsetY) +'px', cursor : dragging ? 'grabbing' : 'grab', backgroundSize: backgroundSize +'px'}">
            <div v-if="!dragging" @mousedown.stop @touchstart.stop v-for="stand in visibleStands" class="position-absolute stand" @mousemove.stop @mouseenter="showStand(stand)" @click="handleClick(stand, $event)" @mouseleave="hideStand(false)" :style="{ cursor : (stand.legend_color && stand.legend_color.map_url && stand.legend_color.map_url[_locale] && !exhibitorsByStand[stand.stand_number]) || exhibitorsByStand[stand.stand_number] && (exhibitorsByStand[stand.stand_number][0].detail_uri || exhibitorsByStand[stand.stand_number].length > 1) && !disableClick ? 'pointer' : 'auto', top : ((stand.position.y - 10) * ratio + backgroundOffsetY + tempOffsetY) +'px', left: ((stand.position.x - 30) * ratio + backgroundOffsetX + tempOffsetX) +'px', width: (65 * ratio) + 'px', height: (25 * ratio) + 'px' }"></div>
            <div style="background-repeat: no-repeat; background-size: contain; background-position: center" class="position-absolute" :class="{ pulsing : pulseCurrentLocation }" v-if="showingCurrentPosition" :style="{ backgroundImage: 'url(\'/img/location-pin.svg?color='+ (pinColor ? pinColor : '') +'\')', width: (110 * ratio) + 'px', height: (110 * ratio) + 'px', top : ((position.y - 120) * ratio + backgroundOffsetY + tempOffsetY) +'px', left: ((position.x - 55) * ratio + backgroundOffsetX + tempOffsetX) +'px'}"></div>
            <div v-if="showingStand" @touchstart.stop @touchend.stop @touchmove.stop @click="handleClick(showingStand, $event)" @mousedown.stop @mouseup.stop @mousemove.stop ref="standInfo" style="width: 200px;" class="position-absolute details shadow-lg p-3 small" :class="{ left : showLeft, right : showRight, below : !showLeft && !showRight && showBelow, above: !showLeft && !showRight && !showBelow }" :style="{ top : tooltipTopPosition +'px', left: tooltipLeftPosition +'px'}">
                <span v-if="exhibitorsByStand[showingStand.stand_number] && exhibitorsByStand[showingStand.stand_number].length == 1">
                    <span v-for="exhibitor in exhibitorsByStand[showingStand.stand_number]">
                        <img :src="exhibitor.logo" v-if="exhibitor.logo" class="img-fluid" @load="setTooltipOffset">
                        <hr v-if="exhibitor.logo">
                        {{ exhibitor.name }}
                        <span class="text-muted mt-2 d-block">{{ showingStand.stand_number }}</span>
                    </span>
                </span>
                <span v-else-if="exhibitorsByStand[showingStand.stand_number] && exhibitorsByStand[showingStand.stand_number].length > 1">
                    <ul>
                        <li v-for="exhibitor in exhibitorsByStand[showingStand.stand_number]">
                            {{ exhibitor.name }}
                        </li>
                    </ul>
                    <hr>
                    <span class="text-muted mt-2 d-block">{{ showingStand.stand_number }}</span>
                </span>
                <span v-else>
                    <span v-if="showingStand.legend_color && showingStand.legend_color.map_text?.[_locale]">
                        {{ showingStand.legend_color.map_text?.[_locale] }}
                    </span>
                    <span v-else>
                        Neem contact op
                    </span>
                </span>
            </div>
            <div class="actions d-none d-md-flex" @mousemove.stop>
                <div class="zoom-wrapper"  data-bs-toggle="vue-tooltip" data-bs-placement="top" :title="__('Drag to zoom in and out')" :style="{ borderColor : borderColor ? '#'+ borderColor : null }" v-if="!disableScrollToZoom">
                    <i class="fa-light fa-magnifying-glass-minus" @click="zoom(-1)"></i>
                    <input type="range" @mousedown.stop class="form-range" min="1" :max="maxZoom" step="0.01" v-model.number="zoomLevel">
                    <i class="fa-light fa-magnifying-glass-plus"@click="zoom(1)"></i>
                </div>
                <div class="zoom-wrapper" style="width: 120px !important; color: white; display: flex; justify-content: space-between"  data-bs-toggle="vue-tooltip" data-bs-placement="top" :style="{ borderColor : borderColor ? '#'+ borderColor : null, backgroundColor : '#'+ pinColor }" v-else-if="!disableZoom">
                    <i class="fa-light fa-2x fa-magnifying-glass-minus" @click="zoom(-1)"></i>
                    <i class="fa-light fa-2x fa-magnifying-glass-plus"@click="zoom(1)"></i>
                </div>
                <div class="search-wrapper" :class="{ dark : disableScrollToZoom }" :style="{ borderColor : borderColor ? '#'+ borderColor : null, backgroundColor : pinColor ? '#'+ pinColor : null }" @click="toggleSearch" v-if="exhibitors.length">
                    <span class="me-2" v-if="disableScrollToZoom">{{ __('Search Exhibitor') }}</span>
                    <span class="me-2" v-else>{{ __('Click here to show which exhibitor is where') }}</span>
                    <i class="fa fa-fw fa-magnifying-glass"></i>
                </div>
                <div class="search-wrapper" data-bs-toggle="vue-tooltip" data-bs-placement="top" :title="__('Click here for an enlarged version of the map')"  :style="{ borderColor : borderColor ? '#'+ borderColor : null }" @click.prevent="downloadMap" v-if="!disableScrollToZoom">
                    <i class="fa fa-download"></i>
                </div>
            </div>
            <div class="search-modal-wrapper" v-if="showSearch" @touchstart.stop>
                <div class="w-100"  style="margin-top: -25%">
                    <div class="bg-white p-4 mx-auto" @mousedown.stop>
                        <v-select :filter="exhibitorFilter" :options="selectableExhibitors" ref="exhibitorSearch" @option:selected="handleSelectedExhibitor"></v-select>
                    </div>
                </div>
            </div>
            <div class="search-modal-wrapper" v-if="showStandDetails">
                <div class="w-100 p-4" style="max-height: 90%; overflow: auto">
                    <div style="width: 600px; max-width: 100%" class="bg-white px-2 pt-3 pb-1 mx-auto row exhibitor-list" @mousedown.stop @mousemove.stop @touchstart.stop @touchmove.stop>
                        <div class="col-md-6 mb-3" v-for="exhibitor in exhibitorsByStand[showStandDetails.stand_number]">
                            <exhibitor :hide-favorite="true" :exhibitor="exhibitor" :new-tab="true"></exhibitor>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mobile-actions d-md-none d-flex mt-2" style="gap: 7px">
            <div class="zoom-wrapper">
                <i class="fa-light fa-magnifying-glass-minus" @click="zoom(-1)"></i>
                <input type="range" @mousedown.stop class="form-range" min="1" :max="maxZoom" step="0.01" v-model.number="zoomLevel">
                <i class="fa-light fa-magnifying-glass-plus" @click="zoom(1)"></i>
            </div>
            <div class="search-wrapper" @click="toggleSearch">
                <i class="fa fa-fw fa-magnifying-glass"></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['img', 'position', 'refresh', 'disable-click', 'disable-scroll-to-zoom', 'disable-zoom', 'map-display-only', 'pin-color', 'border-color'],
    data() {
        return {
            locale : null,
            imageWidth : null,
            imageHeight : null,
            zoomLevel : 1,
            wrapperHeight : 0,
            wrapperWidth : 0,
            dragging : false,
            startX : null,
            startY : null,
            backgroundOffsetX : 0,
            backgroundOffsetY : 0,
            tempOffsetX : 0,
            tempOffsetY: 0,
            mousePositionX : null,
            mousePositionY : null,
            hovering: false,
            stands : [],
            exhibitors: [],
            showingStand : null,
            clickedStand : null,
            tooltipOffset : 70,
            isTouch : false,
            searchQuery : null,
            showSearch: false,
            disableHover : false,
            showStandDetails : null,
            pulseCurrentLocation : false,
            mapImage : null,
            resetTimeout : null,
        }
    },
    methods: {
        exhibitorFilter(options, search) {
            return options.filter((option) => {
                let normalizedLabel = option.label.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
                let normalizedSearch = search.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

                return normalizedLabel.indexOf(normalizedSearch) >= 0;
            });
        },
        setImageSizes() {
            const img = new Image();
            let self = this;
            img.onload = function() {
                self.imageWidth = this.width;
                self.imageHeight = this.height;

                self.mousePositionX = this.width/2
                self.mousePositionY = this.height/2
                self.setWrapperSize();
            }

            img.src = this.mapImage;
        },
        downloadMap() {
            window.open('/'+ this.locale + '/interactive-map/download');
        },
        setWrapperSize() {
            let ratio = this.$refs.wrapper.clientWidth / this.imageWidth;

            this.wrapperHeight = Number.parseInt(this.imageHeight * ratio);
            this.wrapperWidth = Number.parseInt(this.imageWidth * ratio);
        },
        startDrag(e) {
            this.startX = e.touches ? e.touches[0].clientX : e.offsetX;
            this.startY = e.touches ? e.touches[0].clientY : e.offsetY;
            this.showingStand = null;
            this.showStandDetails = null;

            if (!this.isTouch) {
                this.isTouch = e.touches && e.touches.length > 0;
            }

            this.dragging = true;
            this.clickedStand = null;
            this.showSearch = false;
        },
        handleMouseMove(e) {
            if (this.dragging || this.isTouch) {
                this.handleDrag(e);
            }

            if (e.offsetX && e.offsetY) {
                this.mousePositionX = e.offsetX;
                this.mousePositionY = e.offsetY;
            }
        },
        handleDrag(e) {
            this.showingStand = null;
            this.showStandDetails = null;
            this.clickedStand = null;

            let offsetX = e.touches ? e.touches[0].clientX : e.offsetX;
            let offsetY = e.touches ? e.touches[0].clientY : e.offsetY;

            this.tempOffsetX = Math.min(offsetX - this.startX, this.backgroundOffsetX * -1);
            this.tempOffsetY = Math.min(offsetY - this.startY, this.backgroundOffsetY * -1);

            this.tempOffsetX = Math.max(this.tempOffsetX, this.wrapperWidth - this.backgroundOffsetX - (this.zoomLevel * this.wrapperWidth));
            this.tempOffsetY = Math.max(this.tempOffsetY, this.wrapperHeight - this.backgroundOffsetY - (this.zoomLevel * this.wrapperHeight));
        },
        stopDrag() {
            this.backgroundOffsetX += this.tempOffsetX;
            this.backgroundOffsetY += this.tempOffsetY;

            this.tempOffsetX = 0;
            this.tempOffsetY = 0;

            this.dragging = false;
        },
        handleWheel(e) {
            let focusX = this.focusX;
            let focusY = this.focusY;

            this.zoomLevel -= e.deltaY/100;

            this.zoomLevel = Math.max(1, this.zoomLevel);
            this.zoomLevel = Math.min(this.zoomLevel, this.maxZoom);

            let newFocusX = this.focusX;
            let newFocusY = this.focusY;

            this.backgroundOffsetX += (newFocusX - focusX) * this.ratio;
            this.backgroundOffsetY += (newFocusY - focusY) * this.ratio;
        },
        containZoom() {
            this.backgroundOffsetX = Math.min(0, this.backgroundOffsetX);
            this.backgroundOffsetX = Math.max((this.backgroundSize - this.wrapperWidth) * -1, this.backgroundOffsetX);
            this.backgroundOffsetY = Math.min(0, this.backgroundOffsetY);
            this.backgroundOffsetY = Math.max((this.backgroundHeight - this.wrapperHeight) * -1, this.backgroundOffsetY);
        },
        loadStands() {
            let url = '/api/stands';

            if (this.mapDisplayOnly) {
                url += '?for_map_display=1'
            }

            axios.get(url)
                 .then(response => {
                     this.stands = response.data;
                 });
        },
        loadExhibitors() {
            axios.get('/'+ this.locale +'/exhibitors/all')
                 .then(response => {
                     this.exhibitors = response.data;
                 });
        },
        showStand(stand) {
            if (this.disableHover) {
                return;
            }

            this.showingStand = stand;

            Vue.nextTick(() => {
                this.setTooltipOffset();
            })

            // position means interactive display, so hide after 10 seconds
            if (this.position) {
                if (this.resetTimeout) {
                    clearTimeout(this.resetTimeout);
                }

                this.resetTimeout = setTimeout(() => {
                    if (this.isTouch) {
                        this.showingStand = null;
                    }
                }, 20000);
            }
        },
        setTooltipOffset() {
            if (!this.showLeft && !this.showRight) {
                this.tooltipOffset = this.showBelow ? -22 : this.$refs.standInfo.clientHeight + 16 + 15 * this.ratio;
            } else {
                // if we show left or right, the offset is the half of the height
                this.tooltipOffset = this.$refs.standInfo.clientHeight / 2;
            }

        },
        hideStand(forceForTouch) {
            if (this.disableHover || (!forceForTouch  && this.isTouch)) {
                return;
            }

            this.showingStand = null;
            this.clickedStand = null;
        },
        handleClick(stand, e) {
            if (e.pointerType && e.pointerType == 'touch') {
                this.isTouch = true;
            }

            if (this.isTouch && (!this.clickedStand || this.clickedStand.id != stand.id)) {
                this.clickedStand = stand;
                return;
            }

            if (this.disableClick) {
                return;
            }

            if (!this.exhibitorsByStand[stand.stand_number]) {
                if (stand.legend_color && stand.legend_color.map_url && stand.legend_color.map_url[_locale]) {
                    return window.open(stand.legend_color.map_url[_locale], '_blank');
                }

                return;
            }
            if (this.exhibitorsByStand[stand.stand_number].length > 1) {
                this.showingStand = null;
                this.showStandDetails = stand;
                return;
            }
            if (!this.exhibitorsByStand[stand.stand_number][0].detail_uri) {
                return;
            }

            window.open(this.exhibitorsByStand[stand.stand_number][0].detail_uri, '_blank');
        },
        handleSelectedExhibitor(data)
        {
            if (this.standsByStandNumber[data.stand]) {
                this.showStand(this.standsByStandNumber[data.stand]);

                this.disableHover = true;

                setTimeout(() => {
                    this.disableHover = false;
                }, 2000);

                if (this.resetTimeout) {
                    clearTimeout(this.resetTimeout);
                }

                this.resetTimeout = setTimeout(() => {
                    this.showingStand = null;
                }, 20000);

                this.zoomLevel = 1;
            }

            this.showSearch = false;
        },
        zoom(direction) {
            this.zoomLevel += this.maxZoom/10 * direction;

            this.zoomLevel = Math.min(this.maxZoom, this.zoomLevel);
            this.zoomLevel = Math.max(this.zoomLevel, 1);
        },
        toggleSearch()
        {
            this.showSearch = true;

            Vue.nextTick(() => {
                this.$refs.exhibitorSearch.$refs.search.focus();
            });
        },
        reload(image) {
            if (image) {
                this.setImage(image);
            } else {
                axios.get('/api/map')
                    .then(response => {
                        this.setImage(response.data.img)
                    });
            }
        },
        setImage(image)
        {
            this.mapImage = image;

            this.setImageSizes();
            this.loadStands();
            this.loadExhibitors();
        },
        activateTooltips()
        {
            var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="vue-tooltip"]'))
            var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                return new bootstrap.Tooltip(tooltipTriggerEl)
            })
        }
    },
    computed: {
        maxZoom() {
            return this.imageWidth / this.wrapperWidth;
        },
        backgroundSize() {
            return this.wrapperWidth * this.zoomLevel;
        },
        backgroundHeight() {
            return this.wrapperHeight * this.zoomLevel;
        },
        ratio() {
            return this.backgroundSize / this.imageWidth;
        },
        focusX() {
            return (this.mousePositionX - this.backgroundOffsetX) / this.ratio;
        },
        focusY() {
            return (this.mousePositionY - this.backgroundOffsetY) / this.ratio;
        },
        visibleStands() {
            return this.stands.filter((stand) => {
                let pixelPosX = stand.position.x * this.ratio;
                let pixelPosY = stand.position.y * this.ratio;

                return pixelPosX > (this.backgroundOffsetX * -1) && pixelPosX < (this.backgroundOffsetX * -1) + this.wrapperWidth && pixelPosY > (this.backgroundOffsetY * -1) && pixelPosY < (this.backgroundOffsetY * -1) + this.wrapperHeight;
            });
        },
        exhibitorsByStand() {
            let exhibitors = {}

            this.exhibitors.forEach(exhibitor => {
                if (exhibitor.stand) {
                    if (!exhibitors[exhibitor.stand]) {
                        exhibitors[exhibitor.stand] = [];
                    }

                    exhibitors[exhibitor.stand].push(exhibitor);

                    if (exhibitors[exhibitor.stand].length > 1) {
                        exhibitors[exhibitor.stand] = exhibitors[exhibitor.stand].sort((a,b) => {
                           return a.sort_name.toLowerCase() < b.sort_name.toLowerCase() ? -1 : 1;
                        });
                    }
                }
            });

            return exhibitors;
        },
        selectableExhibitors() {
            let list = [];

            this.exhibitors.forEach(exhibitor => {
                if (exhibitor.stand && this.standsByStandNumber[exhibitor.stand]) {
                    list.push({ id : exhibitor.id, label : exhibitor.name, stand : exhibitor.stand });
                }
            });

            return list.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : ((b.label.toLowerCase() > a.label.toLowerCase()) ? -1 : 0));
        },
        standsByStandNumber() {
            let stands = {};
            this.stands.forEach(stand => {
               stands[stand.stand_number] = stand;
            });

            return stands;
        },
        visibleStandsByStandNumber() {
            let stands = {};
            this.visibleStands.forEach(stand => {
                stands[stand.stand_number] = stand;
            });

            return stands;
        },
        showingCurrentPosition()
        {
            if (!this.position) {
                return false;
            }

            let pixelPosX = this.position.x * this.ratio + this.tempOffsetX;
            let pixelPosY = this.position.y * this.ratio + this.tempOffsetY;

            return pixelPosX > (this.backgroundOffsetX * -1) && pixelPosX < (this.backgroundOffsetX * -1) + this.wrapperWidth && pixelPosY > (this.backgroundOffsetY * -1) && pixelPosY < (this.backgroundOffsetY * -1) + this.wrapperHeight;
        },
        showBelow() {
            return (this.position || !this.isTouch) && this.showingStand && (this.showingStand.position.y + this.backgroundOffsetY) * this.ratio < 300;
        },
        showLeft() {
            if (this.mapDisplayOnly) {
                return false;
            }

            let limit = (this.showingStand.position.x * this.ratio + this.backgroundOffsetX) + 100;
            return limit >= this.$refs.wrapper.clientWidth;
        },
        showRight() {
            if (this.mapDisplayOnly) {
                return false;
            }

            let limit = (this.showingStand.position.x * this.ratio + this.backgroundOffsetX) - 100;
            return limit < 0;
        },
        tooltipTopPosition() {
            return this.showingStand.position.y * this.ratio + this.backgroundOffsetY - this.tooltipOffset;
        },
        tooltipLeftPosition() {
            let left = this.showingStand.position.x * this.ratio + this.backgroundOffsetX - 100;

            if (this.showLeft || this.showRight) {
                let offset = 110 + 40 * this.ratio;

                left = this.showLeft ? left - offset : left + offset;
            }

            return left;
        }
    },
    watch: {
        backgroundOffsetX() {
            this.containZoom();
        },
        backgroundOffsetY() {
            this.containZoom();
        },
        zoomLevel() {
            this.containZoom();

            if (!this.isTouch || (this.showingStand && !this.visibleStandsByStandNumber[this.showingStand.stand_number])) {
                this.hideStand(true);
            }
        }
    },
    mounted() {
        this.locale = window._locale;

        // we add a one-time resize listener since the wrapper size needs to be determined after the change.
        addEventListener('orientationchange', (event) => {
            var self = this;

            let afterOrientationChange = function() {
                self.setWrapperSize();

                removeEventListener('resize', afterOrientationChange);
            };

            addEventListener('resize', afterOrientationChange);
        });

        this.eventHub.$on('showCurrentLocation', () => {
            this.pulseCurrentLocation = true;

            setTimeout(() => {
                this.pulseCurrentLocation = false;
            }, 3000);
        });

        this.reload(this.img);

        if (this.refresh) {
            setInterval(() => {
               this.reload()
            }, this.refresh);
        }

        setTimeout(() => {
            this.activateTooltips();
        }, 500);
    }
}

</script>
